<div class="detail-container">
  <nb-card [nbSpinner]="!!(saving$|async)">
    <nb-card-header>
      <h5>Dienstleister Zugriffe</h5>
      @if (canEdit()) {
        <wr-edit-delete-button-group (edit)="onEdit()" [canDelete]="signal(false)"></wr-edit-delete-button-group>
      }
    </nb-card-header>
    <nb-card-body>
      @if (filterForm && isInternalTenant()) {
        <form [formGroup]="filterForm">
          <div class="filter-control-group">
            <label class="label" for="tenant">Kunde</label>
            <wr-tenant-select id="tenant" formControlName="tenantId" [tenantType]="TenantTypeEnum.External"
                              [showEmptyOption]="false"></wr-tenant-select>
          </div>
        </form>
      }
      @if (formSignal() && selectedExternalTenantId()) {
        <wr-split-view>
          <div left class="panel">
            <input nbInput fullWidth placeholder="Dienstleister filtern..." [(ngModel)]="contractorFilterValue">
            <div class="panel-list" #panelList (scroll)="onContainerScroll()">
              @for (scope of visibleContractors(); track scope.contractorId) {
                <div
                  class="list-item"
                  [class.selected]="selectedContractorId() === scope.contractorId"
                  (click)="selectedContractorId.set(scope.contractorId)">
                  <nb-icon pack="eva" icon="person-outline"></nb-icon>
                  <span>{{ scope.contractorName }}</span>
                </div>
              }
            </div>
          </div>
          <div right class="panel">
            @if (selectedContractorControl(); as contractorControl) {
              <span class="panel-title">{{ selectedContractorName() }}</span>
              <form [formGroup]="contractorControl">
                <div class="scope-list">
                  <nb-checkbox formControlName="buildingBaseData">Basisdaten</nb-checkbox>
                  <nb-checkbox formControlName="buildingInspections">Rundgänge</nb-checkbox>
                  <nb-checkbox formControlName="buildingTgas">TGAs</nb-checkbox>
                  <nb-checkbox formControlName="buildingScans">Scans</nb-checkbox>
                  <nb-checkbox formControlName="buildingSensors">EOC</nb-checkbox>
                  <nb-checkbox formControlName="buildingDocuments">Dokumente</nb-checkbox>
                  <nb-checkbox formControlName="buildingEquipmentDocuments">TGA Ordner</nb-checkbox>
                </div>
              </form>
            } @else {
              <div class="no-selection-hint">Wähle einen Dienstleister aus der Liste aus.</div>
            }
          </div>
        </wr-split-view>
      } @else {
        <div class="no-selection-hint">Wähle einen Kunden aus um die Zugriffe der Dienstleister zu sehen!</div>
      }
    </nb-card-body>
    @if (canEdit()) {
      <nb-card-footer>
        <button size="medium" [disabled]="!isEditing" nbButton status="primary" (click)="submit()">Speichern</button>
        <button size="medium" [disabled]="!isEditing" nbButton status="basic" (click)="cancel()">Zurück</button>
      </nb-card-footer>
    }
  </nb-card>
</div>
